import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  status_success: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.contrastText,
  },

  status_warning: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
  },

  status_error: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
  },

  status_info: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText,
  },

  status_primary: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
  },
}));

// COMPONENT
function LayoutStatus({ children, variant, status, className, ...rest }) {
  const { classes, cx } = useStyles();
  const theStatus = status ?? 'info';

  return (
    <div className={cx(classes[`status_${theStatus}`], className)} {...rest}>
      {children}
    </div>
  );
}

export default LayoutStatus;
